import React, { useState } from 'react';
import { AnimateIn, SectionRow } from '../components/Layout';
import { contactContent } from '../data/mock';

const SUBMIT_DELAY_MS = 1000;
const STATUS_CLEAR_DELAY_MS = 3000;
const CONTACT_INFO_DELAY_MS = 280;
const CONTACT_LOCATION_DELAY_MS = 360;
const FORM_BUTTON_DELAY_MS = 500;

const EMPTY_FORM = { name: '', email: '', subject: '', message: '' };

const getSubmitButtonLabel = (status) => {
  if (status === 'sending') return 'Sending...';
  if (status === 'success') return 'Sent!';
  return 'Send Message';
};

const ContactPage = () => {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    // TODO: Connect to backend API when ready
    setTimeout(() => {
      setStatus('success');
      setFormData(EMPTY_FORM);
      setTimeout(() => setStatus(''), STATUS_CLEAR_DELAY_MS);
    }, SUBMIT_DELAY_MS);
  };

  return (
    <div>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <div className="inner">
            <AnimateIn>
              <h1 className="hero-headline" style={{ marginBottom: '24px' }}>
                {contactContent.heroTitle}
              </h1>
            </AnimateIn>
            <AnimateIn delay={100}>
              <p className="hero-desc" style={{ maxWidth: '540px' }}>
                {contactContent.heroDesc}
              </p>
            </AnimateIn>
          </div>
        </div>
      </section>

      <SectionRow number="One" label="Get in Touch" />

      {/* Contact Form + Info */}
      <section className="sec-light sec-pad-lg">
        <div className="inner">
          <AnimateIn>
            <p className="body-text" style={{ maxWidth: '800px', marginBottom: '60px' }}>
              {contactContent.description}
            </p>
          </AnimateIn>

          <div className="contact-grid">
            <div>
              <AnimateIn delay={100}>
                <h3 className="heading-md" style={{ marginBottom: '32px' }}>Send a Message</h3>
              </AnimateIn>
              <form className="contact-form" onSubmit={handleSubmit}>
                {contactContent.fields.map((field, i) => (
                  <AnimateIn key={field.name} delay={150 + i * 80}>
                    <div className="form-group">
                      <label htmlFor={field.name} className="form-lbl">{field.label}</label>
                      {field.type === 'textarea' ? (
                        <textarea
                          id={field.name}
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          placeholder={field.placeholder}
                          className="form-ta"
                          required
                        />
                      ) : (
                        <input
                          type={field.type}
                          id={field.name}
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          placeholder={field.placeholder}
                          className="form-inp"
                          required
                        />
                      )}
                    </div>
                  </AnimateIn>
                ))}
                <AnimateIn delay={FORM_BUTTON_DELAY_MS}>
                  <button 
                    type="submit" 
                    className="form-btn"
                    disabled={status === 'sending'}
                  >
                    {getSubmitButtonLabel(status)}
                  </button>
                </AnimateIn>
              </form>
            </div>

            <div>
              <AnimateIn delay={200}>
                <h3 className="heading-md" style={{ marginBottom: '32px' }}>Direct Contact</h3>
              </AnimateIn>
              <AnimateIn delay={CONTACT_INFO_DELAY_MS}>
                <div style={{ marginBottom: '32px' }}>
                  <div className="label-sm" style={{ marginBottom: '8px' }}>Email</div>
                  <a href={`mailto:${contactContent.email}`} style={{
                    fontFamily: "'Gambarino', Georgia, serif",
                    fontSize: '24px',
                    color: '#101010',
                    textDecoration: 'none'
                  }}>
                    {contactContent.email}
                  </a>
                </div>
              </AnimateIn>
              <AnimateIn delay={CONTACT_LOCATION_DELAY_MS}>
                <div>
                  <div className="label-sm" style={{ marginBottom: '8px' }}>Office</div>
                  <div style={{
                    fontFamily: "'Gambarino', Georgia, serif",
                    fontSize: '20px',
                    color: '#101010',
                    lineHeight: '1.5',
                    whiteSpace: 'pre-line'
                  }}>
                    {contactContent.address}
                  </div>
                </div>
              </AnimateIn>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
